<div>


        <table class="table table-striped custab ticket-dashbaord">
            <thead>
                <tr>
                    <th class="width-100">
                        <strong>{{'customer-ticket-message.Email Correspondence' |translate | translateKey}}</strong>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="ticketMessageHistory && ticketMessageHistory.length > 0">
                <tr *ngFor="let message of ticketMessageHistory;let i = index">
                    <td>
                        <div class="ticket-type">
                            <span *ngIf="message.typeId === ticketMessageType.INCOMINGMAIL">{{'customer-ticket-message.Incoming Email' |translate | translateKey}}</span>
                            <span *ngIf="message.typeId === ticketMessageType.OUTGOINGMAIL">{{'customer-ticket-message.Outgoing Email' |translate | translateKey}}</span>
                       </div>
                       <div class="attachment-align" *ngIf="message.attachments && message.attachments.length > 0 ">
                            <span *ngFor="let attachment of message.attachments; let i = index">
                                <span class="attchment" *ngIf="attachment?.url">
                                    <span class="attachment-link" (click)="downloadDocument(attachment.url,attachment.fileName,message.typeId)"> {{attachment?.fileName}} </span> {{i === message.attachments.length -1 ? ' ' : '|&nbsp;' }}
                                </span>
                            </span>
                        </div>
                       <div>
                          <span class="mail-tags">{{'customer-ticket-message.From' |translate | translateKey}}:</span>
                          <span>{{message.from}}</span>
                       </div>
                       <div>
                            <span class="mail-tags">{{'customer-ticket-message.Sent' |translate | translateKey}}:</span>
                            <span>{{message.sentDate | date :'EEEE, dd-MMM-yy h:mm'}}</span>
                        </div>
                         <div>
                            <span class="mail-tags">{{'customer-ticket-message.To' |translate | translateKey}}:</span>
                             <span>{{message.to.join(', ')}}</span>
                        </div>
                        <div>
                            <span *ngIf="message && message.cc && message.cc.length > 0" class="mail-tags">{{'customer-ticket-message.CC' |translate | translateKey}}:</span>
                            <span>{{message.cc.join(', ')}}</span>
                        </div>
                        <div>
                            <span *ngIf="message && message.bcc && message.bcc.length > 0" class="mail-tags">{{'customer-ticket-message.BCC' |translate | translateKey}}:</span>
                            <span>{{message.bcc.join(', ')}}</span>
                        </div>
                        <div>
                            <span class="mail-tags">{{'customer-ticket-message.Subject' |translate | translateKey}}:</span>
                            <span>{{message.subject}}</span>
                        </div>
                        <div *ngIf="message && message.mailBody">
                           <div class="mail-body" [id]="'mail-body' + i" >
                                <div id="ticket-message-body" class="desc-container" #mailBody [class.show-less]="!message[i]" [embedHTML]="message.mailBody | sanitizeHtml"> </div>
                                <span class="show-message" (click)="message[i] = true" *ngIf="!message[i] && mailBody.scrollHeight > 130">
                                    {{'customer-ticket-message.Read More' | translate | translateKey}}>>
                                 </span>
                                 <span class="show-message" (click)="message[i] = false" *ngIf="message[i]">
                                   {{'customer-ticket-message.Show Less' | translate | translateKey}}
                             </span>
                            </div>
                         </div>

                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="ticketMessageHistory && ticketMessageHistory.length===0">
                    <tr>
                        <td class="text-center">
                            {{'customer-ticket-message.No Email history on this ticket' |translate |translateKey}}
                        </td>
                    </tr>
             </tbody>
        </table>

</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/ticket-email-history.component.html